import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e74de386"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "row small-gutter no-space" }
const _hoisted_7 = {
  key: 0,
  class: "col-2"
}
const _hoisted_8 = { class: "form-element" }
const _hoisted_9 = {
  key: 0,
  class: "label"
}
const _hoisted_10 = { class: "form-element" }
const _hoisted_11 = { class: "form-element" }
const _hoisted_12 = { class: "arrangement-checklist" }
const _hoisted_13 = { class: "row justify-between" }
const _hoisted_14 = { class: "col-8" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "col-4"
}
const _hoisted_17 = { class: "total-share writers" }
const _hoisted_18 = { class: "text-total-share" }

import { computed, ComputedRef, toRefs } from 'vue'
import { useGettext } from 'vue3-gettext'
import { useFieldArray, useFieldError, ErrorMessage, FieldEntry, useValidateForm } from 'vee-validate'
import DropdownUI from '@/components/CommonUI/DropdownUI.vue'
import IconUI from '@/components/CommonUI/IconUI.vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import TextField from '@/components/CommonUI/TextField.vue'
import WriterNameSelector from '@/components/AddWork/WriterNameSelector.vue'
import {
  emptyWriter,
  WriterRolesDropdownOptions,
  maxWorkWritersCount,
  singleArrangerError,
  WriterStatuses,
  getWriterStatusColor,
} from '@/constants'
import { useWorksStore } from '@/store/works'
import WriterActions from '@/components/MyWorks/WriterActions.vue'
import { useUserStore } from '@/store/user'

interface Props {
  track: Track,
  workId?: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkWriters',
  props: {
    track: {},
    workId: { default: undefined }
  },
  setup(__props: any) {

const props = __props;


const { track, workId } = toRefs(props)

const { $gettext } = useGettext()
const { remove, replace, push, fields, update } = useFieldArray('writers')
const validateForm = useValidateForm()

const workStore = useWorksStore()
const userStore = useUserStore()

const writers: ComputedRef<Writer[]> = computed(() => fields.value.map(entry => entry.value as Writer))
const isCopySharesDisabled = computed((): boolean => writers.value.some(writer => writer.status === WriterStatuses.approve))
const isPossibleToAddWriter = computed((): boolean => {
  const approvedShares: number = writers.value.reduce((acc, writer): number => {
    if (writer.status === WriterStatuses.approve) {
      return acc + Number(writer?.share)
    }

    return acc
  }, 0)

  return approvedShares < 100
})
const totalShare = computed(() => {
  const entriesWithData = writers.value.filter(writer => writer.name && writer.email && writer.share && writer.role)
  return entriesWithData.reduce((acc, { share }) => parseFloat(String(acc)) + parseFloat(String(share)), 0)
})
const registeredWorksOptions = computed(() => workStore.works.map<DropdownOption>(
  work => ({
    id: Number(work.id),
    name: String(work.title),
  }),
))

const hasSingleArranger = computed(
  () => useFieldError('writers').value === $gettext(singleArrangerError),
)

function selectWriterName(user: LinkedAccountOption, index: number) {
  const writer = fields.value[index]
  update(index, { ...writer, name: user.name, email: user.email })
}

async function copyShareFromWork(id: number) {
  const selectedWork = workStore.getWorkById(id)

  if (selectedWork) {
    const writersCopy: Writer[] = structuredClone(selectedWork.writers)
    const formattedWriters = writersCopy.map<Writer>(
      ({ name, email, role, share, linked_user_id }) => ({ name, email, role, share, linked_user_id }),
    )

    replace(formattedWriters)

    await validateForm()
  }
}

function isWriterApproved(writer: Writer): boolean {
  return writer.status === WriterStatuses.approve
}

function isShowWriterActions(writer: Writer) {
  return workId.value && writer.status === WriterStatuses.requested && writer.user_id !== userStore.user.id
}

function emailsSentHandler(index: number) {
  const writer = fields.value[index] as FieldEntry<Writer>
  update(index, { ...writer.value, sent_emails: (writer.value.sent_emails || 0) + 1 })
}

function writerAcceptShareHandler(index: number) {
  const writer = fields.value[index] as FieldEntry<Writer>
  update(index, { ...writer.value, isControlled: false })
}

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("p", null, [
      _createTextVNode(" Writers ")
    ])), [
      [_directive_translate]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields) as FieldEntry<Writer>[], (entry, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: entry.key,
        class: "row no-space",
        "data-testid": `work-writer${index}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(WriterNameSelector, {
            index: index,
            writers: writers.value,
            track: _unref(track),
            disabled: isWriterApproved(entry.value),
            onUpdateOption: selectWriterName
          }, null, 8, ["index", "writers", "track", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TextField, {
            name: `writers[${index}].email`,
            "tooltip-info-text": _unref($gettext)('Enter the email address of the writer who should receive royalties. If the writer already has a Ditto Music account, please enter the email address associated with that account. We will send an email to the writer prompting them to confirm their royalty shares. The writer will need to confirm the shares on his ditto dashboard.'),
            label: _unref($gettext)('Email'),
            placeholder: _unref($gettext)('Enter email'),
            "hide-label": index > 0,
            disabled: isWriterApproved(entry.value)
          }, null, 8, ["name", "tooltip-info-text", "label", "placeholder", "hide-label", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(DropdownUI, {
            class: "field-container",
            label: index === 0 ? _unref($gettext)('Writer Role') : null,
            placeholder: _unref($gettext)('Select Role'),
            options: _unref(WriterRolesDropdownOptions),
            name: `writers[${index}].role`,
            "data-testid": `writers[${index}].role`,
            disabled: isWriterApproved(entry.value)
          }, null, 8, ["label", "placeholder", "options", "name", "data-testid", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(TextField, {
              class: "col-3",
              label: _unref($gettext)('Share'),
              unit: "%",
              name: `writers[${index}].share`,
              "tooltip-info-text": _unref($gettext)('All contributors involved in the creation of an original Musical Work must agree to the royalty share percentage they control before registering a claim.'),
              "hide-label": index > 0,
              disabled: isWriterApproved(entry.value)
            }, null, 8, ["label", "name", "tooltip-info-text", "hide-label", "disabled"]),
            (entry.value.status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("fieldset", _hoisted_8, [
                    (index === 0)
                      ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_9, [
                          _createTextVNode(" Status ")
                        ])), [
                          [_directive_translate]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["status", _unref(getWriterStatusColor)(entry.value.status)])
                    }, null, 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            (isShowWriterActions(entry.value))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["col-5", { 'empty-label': index === 0 }])
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(WriterActions, {
                      "writer-id": Number(entry.value.id),
                      "work-id": Number(_unref(workId)),
                      "sent-emails": Number(entry.value.sent_emails),
                      "writer-created-date": entry.value.created_at,
                      "is-controlled": entry.value.isControlled,
                      onEmailSent: ($event: any) => (emailsSentHandler(index)),
                      onWriterShareAccepted: ($event: any) => (writerAcceptShareHandler(index))
                    }, null, 8, ["writer-id", "work-id", "sent-emails", "writer-created-date", "is-controlled", "onEmailSent", "onWriterShareAccepted"])
                  ])
                ], 2))
              : _createCommentVNode("", true),
            ((index > 0 || entry.value.status) && !isWriterApproved(entry.value))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["col-2", { 'empty-label': index === 0 }])
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(IconUI, {
                      class: "delete-button",
                      name: "rubbish-bin",
                      fill: "body",
                      "data-testid": `remove-writer${index}`,
                      onClick: ($event: any) => (_unref(remove)(index))
                    }, null, 8, ["data-testid", "onClick"])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ])
      ], 8, _hoisted_1))
    }), 128)),
    _createVNode(_unref(ErrorMessage), { name: "writers" }, {
      default: _withCtx(({ message }) => [
        (!hasSingleArranger.value)
          ? (_openBlock(), _createBlock(NotificationUI, {
              key: 0,
              class: "col-10",
              message: message,
              type: "error outline",
              "icon-fill": "error",
              "icon-name": "danger"
            }, null, 8, ["message"]))
          : (_openBlock(), _createBlock(NotificationUI, {
              key: 1,
              class: "col-10",
              type: "error outline",
              "icon-fill": "error",
              "icon-name": "danger"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(message), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref($gettext)('If you would like to proceed with registering an arrangement, please send the following details to publishing-registrations@dittomusic.com')), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", null, _toDisplayString(_unref($gettext)('Main Title of Original Musical Work')), 1),
                      _createElementVNode("li", null, _toDisplayString(_unref($gettext)('Composer/s of Original Musical Work')), 1),
                      _createElementVNode("li", null, _toDisplayString(_unref($gettext)('Documentation confirming clearance of your arrangement with the original copyright owners, or confirmation that the work is in the public domain')), 1)
                    ])
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_unref($gettext)('If this is a completely new composition, please credit yourself as either a Composer (Music), Author (Lyrics) or Composer/Author (Music and Lyrics).')), 1)
                ])
              ]),
              _: 2
            }, 1024))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "button text-button action-button",
          disabled: writers.value.length === _unref(maxWorkWritersCount) || !isPossibleToAddWriter.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(push)(_unref(emptyWriter))))
        }, [
          _createVNode(IconUI, { name: "plus-circle" }),
          _withDirectives((_openBlock(), _createElementBlock("span", null, [
            _createTextVNode("Add another writer")
          ])), [
            [_directive_translate]
          ])
        ], 8, _hoisted_15),
        _createVNode(DropdownUI, {
          class: "copy-share-dropdown",
          "toggle-class": "button secondary with-caret",
          "toggle-text": _unref($gettext)('Copy shares from'),
          options: registeredWorksOptions.value,
          name: "copyShares",
          disabled: !registeredWorksOptions.value.length || isCopySharesDisabled.value,
          "full-width": false,
          "onUpdate:modelValue": copyShareFromWork
        }, null, 8, ["toggle-text", "options", "disabled"])
      ]),
      (totalShare.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_18, [
                _createTextVNode("Total writers share:")
              ])), [
                [_directive_translate]
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(totalShare.value === 100 ? 'text-success' : 'text-error')
              }, _toDisplayString(totalShare.value) + "% ", 3),
              _createVNode(IconUI, {
                name: totalShare.value === 100 ? 'verified' : 'error',
                fill: totalShare.value === 100 ? 'success' : 'error'
              }, null, 8, ["name", "fill"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})